import React from 'react';
import moment from 'moment';
import Request from '../../request';

class ReceiptsPDF extends React.Component {
    render() {
        const { generatedReceipts } = this.props;
        let generatedReceiptsHtml = [];
        let totalSubAmount = 0;
        let totalCgst = 0;
        let totalSgst = 0;
        let totalAmount = 0;
        generatedReceipts && generatedReceipts.map((generatedReceipt) => {
            totalSubAmount += parseFloat(generatedReceipt.amount);
            totalCgst += generatedReceipt.cgstRate?parseFloat(generatedReceipt.cgstRate):0;
            totalSgst += generatedReceipt.sgstRate?parseFloat(generatedReceipt.sgstRate):0;
            totalAmount += parseFloat(generatedReceipt.totalAmount);
            generatedReceiptsHtml.push(<tr>
                <td className="service">{generatedReceipt.receiptNumber}</td>
                <td className="service">{generatedReceipt.amountType}</td>
                <td className="desc">{generatedReceipt.studentName}</td>
                <td className="desc">{generatedReceipt.studentMobile}</td>
                <td className="unit">{generatedReceipt.dob}</td>
                <td className="qty">{generatedReceipt.totalAmount?generatedReceipt.totalAmount.toFixed(2):'0.00'}</td>
            </tr>);
            return
        })
        
        return (        
            <div>
                <div className="receipt-body">
                    <header className="clearfix receipt-header">
                        <div id="receipt-header-logo">
                            <img src="/tp-logo.jpg" />
                        </div>
                        <h1 className="receipt-title">Receipt</h1>
                        <div id="receipt-header-company" className="clearfix">
                            <div>Turning Point Studies Consultants</div>
                            <div>Prabhu Dayal Tower, 1-Atal Park,<br />
                                Ram Mandir Marg, Sector-8, Karnal,<br />
                                132001-Haryana, India</div>
                            <div>+91 9813216000</div>
                            <div>info@turningpoint.in</div>
                        </div>
                        <div id="receipt-header-student">
                            <div><span>Receipt Date</span> {moment().format('lll')} </div>
                        </div>
                    </header>
                    <main>
                        <table className="receipt-header-details">
                            <thead>
                                <tr>
                                    <th className="service">Receipt Number</th>
                                    <th className="service">SERVICE</th>
                                    <th className="desc">Student Name</th>
                                    <th className="desc">Student Mobile</th>
                                    <th>DOB</th>
                                    <th>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {generatedReceiptsHtml}                        
                                <tr>
                                    <td colSpan="5">SUBTOTAL</td>
                                    <td className="total">{totalSubAmount.toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td colSpan="5">CGST</td>
                                    <td className="total">{totalCgst.toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td colSpan="5">SGST</td>
                                    <td className="total">{totalSgst.toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td colSpan="5" className="grand total">GRAND TOTAL</td>
                                    <td className="grand total">{totalAmount.toFixed(2)}</td>
                                </tr>
                            </tbody>
                        </table>
                    </main>
                    <footer className="receipt-footer">
                        Receipt was created on a computer and is valid without the signature and seal.
                    </footer>
                </div>
            </div>
        )
    }
};
export default ReceiptsPDF;